<template>
  <div :class="{ hidden: !isActive }">
    <div
      tabindex="0"
      class="fixed inset-0 z-9999 flex items-center justify-center overflow-hidden"
      aria-busy="false"
      aria-label="Loading"
    >
      <div class="absolute inset-0 bg-white opacity-70 backdrop-blur-[2px]"></div>
      <div class="relative">
        <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#4f46e5">
          <g fill="none" fill-rule="evenodd">
            <g transform="translate(1 1)" stroke-width="2">
              <circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle>
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 18 18"
                  to="360 18 18"
                  dur="0.8s"
                  repeatCount="indefinite"
                ></animateTransform>
              </path>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { rollbar } from "@/rollbar";
import { mapMutations, mapState } from "vuex";

export default {
  components: {},

  data: () => {
    return {
      active: true,
      loadingTimeout: 35000, // milliseconds – safety net; actual timeout is handled by axios per-request
      loadingTimeoutId: null,
    };
  },

  computed: {
    ...mapState("store", ["isLoading"]),

    isActive() {
      return this.active && this.isLoading;
    },
  },

  methods: {
    ...mapMutations("store", ["setIsLoading"]),
  },

  watch: {
    isLoading(newValue) {
      // Prevent infinite loading...
      // Ensure the loader active for at most for X seconds
      window.clearTimeout(this.loadingTimeoutId);
      this.active = newValue;
      if (!this.active) return;

      this.loadingTimeoutId = window.setTimeout(() => {
        this.active = false;
        this.setIsLoading(false);
        const error = `Loading timeout after ${this.loadingTimeout}ms on ${this.$route.fullPath}`;
        console.error(error);
        rollbar.error(error);
      }, this.loadingTimeout);
    },
  },
};
</script>
